/*
For more information about authentication adapters, visit:
- https://manual.os-js.org/v3/tutorial/auth/
- https://manual.os-js.org/v3/guide/auth/
- https://manual.os-js.org/v3/development/
*/

import LocalStorageAdapter from "./localStorageAdapter.js";
import OktaAuth from "@okta/okta-auth-js";

const loginAdapter = (core, config) => ({
  login: async (req, res) => {
    const splash = core.make("oxzion/splash");
    const helper = core.make("oxzion/restClient");
    core.on("osjs/core:boot", () => splash.show());
    core.on("osjs/core:booted", () => splash.destroy());
    core.on("osjs/core:logged-in", () => splash.show());
    core.on("osjs/core:started", () => splash.destroy());
    localStorage.clear();
    localStorage.removeItem("userInfo");
    var lsHelper = new LocalStorageAdapter();
    let response = {};
    let username = "";
    const authType = core.config("authType");

    if (authType && !window.location.href.includes("#login")) {
      response = req[0].result;
      username = req[0].result.username;
    } else {
      const formData = new FormData();
      formData.append('username', req.username);
      formData.append('password', req.password);

      response = await fetch(core.config("wrapper.url") + "auth", {
      method: "POST",
      body: formData,
      credentials: 'include',
      },'json');
      response = await response.json();
      response=response.data;
      username = req.username;
    }

    if ((lsHelper.supported() || lsHelper.cookieEnabled()) && response["jwt"] != null) {
      lsHelper.purge("AUTH_token");
      lsHelper.purge("REFRESH_token");
      lsHelper.purge("KC_REFRESH_token");
      lsHelper.purge("User");
      lsHelper.purge("UserInfo");
      lsHelper.purge("Metadata");
      lsHelper.purge("osjs/session");
      lsHelper.purge("osjs/locale");
      lsHelper.purge("osjs/desktop");
      lsHelper.set("User", username);
      lsHelper.set("AUTH_token", response["jwt"]);
      lsHelper.set("REFRESH_token", response["refresh_token"]);

      const tokenMap = {
        keycloak: () => lsHelper.set("KC_REFRESH_token", req[0]?.ref_token),
        okta: () => lsHelper.set("id_token", req[0]?.id_token)
      };
      req[0] && authType && tokenMap[authType]?.();

      let user = {
        jwt: response["jwt"],
        refresh_token: response["refresh_token"],
        username: username,
      };
      core.setUser(user);

      let userSession = await helper.request("v1", "/user/me", {}, "GET");
      //If a request is made for the user's cache to be cleared, then this function will be triggered and cache will be cleared from the browser
      if (userSession["data"]["cleared_browser_cache"] == 1) {
        clearCacheData();
        localStorage.clear();
        caches.keys().then((names) => {
          names.forEach((name) => {
            caches.delete(name);
          });
        });
        // localStorage.clear();
        // localStorage.setItem("version", packageJson.version);
        // window.location.reload(true);
        //Update the user cache value to 0
        await helper.request(
          "v1",
          "/user/" + userSession["data"]["id"],
          JSON.stringify({
            cleared_browser_cache: 0,
          }),
          "PUT",
        );
      }
      return Promise.resolve(user);
    } else {
      console.log("login failed.");
      return Promise.reject(new Error(res.message));
    }
  },

  logout: async (req, res) => {
    var lsHelper = new LocalStorageAdapter();
    lsHelper.supported();

    switch (core.config("authType")) {
      case "keycloak":
        const kcReftoken = lsHelper.get("KC_REFRESH_token");
        if (kcReftoken) {
          const formData = new FormData();
          const realm = core.config("keycloak.keycloakRealm");
          formData.append("client_id", realm + "-cli");
          formData.append("redirect_uri", core.config("ui.url"));
          formData.append("refresh_token", kcReftoken["key"]);  
          const response = await fetch(
            core.config("keycloak.keycloakUrl") +
              "realms/" +
              realm+
              "/protocol/openid-connect/logout",
            {
              body: new URLSearchParams(formData),
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
            }
          );
        }
        break;
      case "okta":
        const oktaIssuer = core.config("okta.oktaIssuer");
        const oktaClientId = core.config("okta.oktaClientId");
        const oktaRedirectUri = core.config("okta.oktaRedirectUri"); // Set this to your frontend URL

        let oktaAuth = new OktaAuth({
          issuer: oktaIssuer,
          clientId: oktaClientId,
          redirectUri: oktaRedirectUri,
        });
        oktaAuth.session.close();
        break;
      default:
        break;
    }

    try {
      await core.make("osjs/session")?.save();
      await core.make("oxzion/usersession")?.remove();
    } catch (error) {}
    if (lsHelper.supported() || lsHelper.cookieEnabled()) {
      lsHelper.purge("AUTH_token");
      lsHelper.purge("REFRESH_token");
      lsHelper.purge("User");
      lsHelper.purge("UserInfo");
      lsHelper.purge("Metadata");
      lsHelper.purge("osjs/session");
      lsHelper.purge("osjs/locale");
      lsHelper.purge("osjs/desktop");
      localStorage.removeItem("userInfo");
      return Promise.resolve(true);
    }
  },
});

export default loginAdapter;
